import React, { useEffect, useMemo, useState, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { getWaitTicketById } from "@/apis";
import { BigButton } from "@/components/button";
import { useQuery } from "@/utils";
import { useGlobalState } from "@/hooks/useGlobalState";

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    color: "#4a4f54",
  },
  marginTop: {
    marginTop: 72,
    "@media (max-height: 768px)": {
      marginTop: 72,
    },
  },
  font: {
    fontSize: 36,
    fontWeight: 500,
  },
  number: {
    width: 180,
    height: 180,
    margin: "32px auto",
    borderRadius: "187px",
    border: "solid 3px #fbd133",
    fontSize: 80,
    fontFamily: "Roboto",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  kioskNumber: {
    fontSize: 93,
  },
  position: {
    margin: "0 auto",
    fontSize: "36px",
    fontWeight: 500,
    color: "#4a4f54",
  },
  youllreceive: {
    width: 449,
    margin: "0 auto",
    marginTop: 32,
    fontSize: "27px",
    textAlign: "center",
    color: "#4a4f54",
    "@media (max-height: 768px)": {
      marginTop: 32,
      marginBottom: -34,
    },
  },
  youllreceivekiosk: {
    width: 600,
    margin: "0 auto",
    marginTop: 40,
    fontSize: "27px",
    textAlign: "center",
    color: "#4a4f54",
    "@media (max-height: 768px)": {
      marginTop: 32,
      marginBottom: -34,
    },
  },
  space: {
    width: 10,
  },
  chinese: {
    "@media (max-height: 768px)": {
      display: "none",
    },
  },
});

const WaitingNumber = () => {
  const [language] = useGlobalState("language");
  const timer = useRef(null);
  const classes = useStyles();
  const navigate = useNavigate();
  const search = useLocation().search;
  const { mode } = useQuery();
  const startPage = window.location.pathname.replace(/\/[^\/]*$/, "/start");
  const id = new URLSearchParams(search).get("id");
  const [ticket, setTicket] = useState({ waitingNumber: "", position: "" });
  const [countdown, setCountdown] = useState(15);

  const startCountDown = () => {
    if (timer.current) return;
    timer.current = setInterval(() => {
      setCountdown((prevState) => {
        if (prevState === 1) {
          onClose();
          clearInterval(timer.current);
        }
        return prevState - 1;
      });
    }, 1000);
  };

  const getData = async () => {
    if (id) {
      try {
        const wait = await getWaitTicketById(id);
        const { waitingNumber, position } = wait.data;
        setTicket({ waitingNumber, position });
        window.parent.postMessage({ type: "waitListComplete" }, "*");
        startCountDown();
      } catch (e) {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const onClose = () => {
    if (mode === "kiosk") {
      window.parent.postMessage({ type: "waitListClose" }, "*");
    } else {
      navigate(startPage);
    }
    timer.current && clearInterval(timer.current);
  };

  const isShowCn = useMemo(() => {
    return language.includes("zh");
  }, [language]);

  return (
    <div className={classes.root}>
      <div className={`${classes.marginTop} ${classes.font}`}>
        Your waiting number is
      </div>
      {isShowCn && (
        <div className={`${classes.font} ${classes.chinese}`}>
          您的等位号码是
        </div>
      )}
      <div className={classes.number}>{ticket.waitingNumber}</div>
      <div className={classes.position}>Estimated wait: </div>
      <div className={classes.position}>
        {Number(ticket.position || 0) - 1} parties ahead of you
      </div>
      {isShowCn && (
        <div className={`${classes.position} ${classes.chinese}`}>
          <span>预计等待 :</span>
          <span>{ticket.position}</span>
          <span>桌</span>
        </div>
      )}

      {mode !== "kiosk" ? (
        <div className={classes.youllreceive}>
          <span>You'll receive texts about your place in line.</span>
          {isShowCn && <span>请注意查收短信</span>}
        </div>
      ) : (
        <div className={classes.youllreceivekiosk}>
          You'll receive texts about your place in line. We will message you
          when your table is ready.
        </div>
      )}
      <BigButton onClick={onClose} mode={mode}>
        <span>Close</span>
        {isShowCn && <span>(关闭)</span>}
        <span className={classes.space}></span>
        <span>{`(${countdown}s)`}</span>
      </BigButton>
    </div>
  );
};

export default WaitingNumber;
